import { render, staticRenderFns } from "./archive.vue?vue&type=template&id=54696ed3"
import script from "./archive.vue?vue&type=script&lang=js"
export * from "./archive.vue?vue&type=script&lang=js"
import style0 from "./archive.vue?vue&type=style&index=0&id=54696ed3&prod&lang=scss"
import style1 from "./archive.vue?vue&type=style&index=1&id=54696ed3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports